// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"880f83e2","157":"7ac36d38","195":"ca08ee00","278":"389c6f3f","321":"e028df0a","341":"839d745c","411":"54cd77f1","577":"81db44d4","765":"2a363e78","787":"59a5d541","826":"b4e009ca","906":"8deaac36"}[chunkId] + ".chunk.js";
};